import { useRef, Fragment, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Formik, Field } from 'formik';
import styled, { withTheme } from 'styled-components';
import { useCookies } from 'react-cookie';
import * as yup from 'yup';

import {
    FovInput,
    FovFieldError,
    VerticalSpacer,
    FovButton,
    FovModal,
} from 'components';

import { createOrganizationAdmin } from 'store/actions/adminActions/organizations';

const ButtonContainer = styled('div')`
    display: inline-flex;
    width: 100%;
    max-width: 25rem;
`;

const InputContainer = styled('div')`
    max-width: 25rem;
`;

const AddOrganizationForm = withTheme(props => {
    const { isVisible, onClose } = props;

    const dispatch = useDispatch();
    const formikRef = useRef();

    const [ cookies ] = useCookies([ 'userAuth' ]);
    const token = cookies.archvision_token;

    const setRef = form => {
        if (!formikRef.current) {
            formikRef.current = form;
        }
    };

    const handleSubmit = useCallback(args => {
        const { values, setSubmitting } = args;
        const { name, max_seats } = values;

        dispatch(createOrganizationAdmin(
            token,
            { name, max_seats },
        ))
            .finally(() => {
                setSubmitting(false);
                onClose();
            });
    }, []);

    const defaults = {
        name: '',
        max_seats: 0,
    };

    const schema = yup.object().shape({
        name: yup.string().required('A display name is required.'),
        max_seats: yup.number().positive().required('A max number of seats is required'),
    });


    return (
        <FovModal
            title='Create an organization'
            visible={isVisible}
            onClose={onClose}
        >
        <Fragment>
            <Formik
                initialValues={defaults}
                validationSchema={schema}
                onSubmit={(values, handlers) => {
                    const { setSubmitting } = handlers;
                    handleSubmit({ values, setSubmitting });
                }}
                validateOnChange={true}
            >
            {form => (
                <Fragment>
                {setRef(form)}
                Organization Name
                <Field type='text' name='name'>
                {data => (
                    <InputContainer>
                        <FovInput
                            value={data.field.value}
                            placeholder={''}
                            {...data.field}
                            onChange={e => {
                                const newVal = e.target.value;
                                form.setFieldValue(data.field.name, newVal);
                            }}
                        />
                    </InputContainer>
                )}
                </Field>
                <FovFieldError name='name' />

                Max Seats
                <VerticalSpacer size={10} />

                <Field type='input' name='max_seats'>
                {data => (
                    <FovInput
                        value={data.field.value}
                        placeholder={0}
                        min={0}
                        {...data.field}
                        type={'number'}
                        onChange={e => {
                            const newVal = e.target.value;
                            form.setFieldValue(data.field.name, newVal);
                        }}
                    />
                )}
                </Field>
                <FovFieldError name='max_seats' />
                <ButtonContainer>
                    <FovButton
                        type='submit'
                        disabled={form.isSubmitting}
                        onClick={form.handleSubmit}
                    >
                    Add Organization
                    </FovButton>
                </ButtonContainer>


                </Fragment>
            )}
            </Formik>
        </Fragment>
        </FovModal>
    );
});

export { AddOrganizationForm };
